import "~/misc/common";
import { p, selectObjects } from "~/misc/common";
import L from "~/misc/2d/leaflet";
import { Context2d } from "~/types/map";

interface BaseLayerInfo {
  id: string;
  name: string;
  layer: L.Layer;
}

export function initMapLayers(map: Context2d) {
  p('initMapLayers');

  const baseLayers: BaseLayerInfo[] = [];
  let currentLayer: BaseLayerInfo | undefined;

  map.tree.create_node('#', {
    id: 'basemap',
    icon: 'bi-map',
    text: "Alaptérkép",
    "li_attr": { "class": "radio-parent" },
    state: {
      disabled: true
    }
  }, 'first');

  $('#basemap_anchor').on('click', function () {
    map.tree.toggle_node('basemap');
  });

  addSatellite();
  addMapy();

  for (const layerInfo of baseLayers) {
    map.tree.create_node('basemap', {
      id: 'basemap_' + layerInfo.id,
      icon: 'bi-circle',
      text: layerInfo.name
    });
  }

  if (map.noState) {
    map.tree.open_node('basemap');
  }

  map.tree.element.on("state_ready.jstree", function () {
    if (!currentLayer) changeTo('satellite');
  });

  map.tree.element.on("check_node.jstree", function (e: any, d: any) {
    if (d.node.parent == 'basemap') {
      p(d.node);
      changeTo(d.node.id.substring("basemap_".length));
    }
  });

  function changeTo(layer_id: string) {
    const children = map.tree.get_children_dom('basemap');
    if (children && typeof children !== 'boolean') {
      children.each((_index: number, element: HTMLElement) => {
        if (`basemap_${layer_id}` !== element.id) {
          map.tree.uncheck_node(element.id, null);
        }
        map.tree.enable_node(element.id);
        map.tree.set_icon(element.id, 'bi-circle');
      });
    }

    if (currentLayer) {
      map.removeLayer(currentLayer.layer);
    }
    currentLayer = selectObjects(baseLayers, 'id', layer_id)[0];
    map.addLayer(currentLayer.layer);

    map.tree.check_node('basemap_' + currentLayer.id, null);
    map.tree.disable_node('basemap_' + currentLayer.id);
    map.tree.set_icon('basemap_' + currentLayer.id, 'bi-record-circle');

    map.fire('baselayerchange');
  }

  //L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
  //	attribution: 'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
  //	maxZoom: 19
  //}).addTo(map);
  //L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //	maxZoom: 19,
  //	attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  //}).addTo(map);
  // Esri Reference Labels (roads, cities, names)
  //var esriLabels = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', {
  //	attribution: 'Labels © Esri',
  //	maxZoom: 19,
  //	pane: 'overlayPane'
  //}).addTo(map);
  // Roads and labels overlay from Carto (light OSM style)
  //var cartoRoads = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png', {
  //	attribution: '&copy; OpenStreetMap contributors & Carto',
  //	subdomains: 'abcd',
  //	maxZoom: 20,
  //	pane: 'overlayPane'
  //}).addTo(map);
  // Roads and city labels overlay
  //var esriLabels = L.tileLayer(
  //	'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}', {
  //	attribution: '© Esri',
  //	maxZoom: 19,
  //	opacity: 0.8
  //}).addTo(map);
  //
  //// Optional: Add city/place names overlay too
  //var esriPlaces = L.tileLayer(
  //	'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', {
  //	attribution: '© Esri',
  //	maxZoom: 19,
  //	opacity: 0.8
  //}).addTo(map);

  return map;

  function addSatellite() {
    const API_KEY2 = 'UaZGBv3WzRwHz2iHB5av';
    const maptiler = false;

    let layer;
    if (maptiler) {
      layer = L.tileLayer(`https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.png?key=${API_KEY2}`, {
        attribution: '© MapTiler, OpenStreetMap contributors',
        maxZoom: 20,
        tileSize: 512,
        zoomOffset: -1
      });
    } else {
      //'Műhold': L.tileLayer(`https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=${API_KEY2}`, {
      //	attribution: '© MapTiler, OpenStreetMap contributors',
      //	maxZoom: 20
      //}),
      //'Műhold': L.tileLayer('https://tiles.openaerialmap.org/xyz/{z}/{x}/{y}.png', {
      //	attribution: 'Imagery © OpenAerialMap contributors',
      //	maxZoom: 19
      //}),
      layer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
        maxZoom: 19
      });
    }
    const layerInfo: BaseLayerInfo = { id: 'satellite', name: 'Műhold', layer: layer };

    baseLayers.push(layerInfo);
  }

  function addMapy() {
    const API_KEY = 'vE7YgMIJypqAEWQSZfeZMtHIHb7peTAX0hpAzXdFDQE';
    const mapy_attribution = '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>';
    const LogoControl = L.Control.extend({
      options: {
        position: 'bottomleft',
      },
      onAdd: function () {
        const container = L.DomUtil.create('div');
        const link = L.DomUtil.create('a', '', container);

        link.setAttribute('href', 'http://mapy.cz/');
        link.setAttribute('target', '_blank');
        link.innerHTML = '<img src="https://api.mapy.com/img/api/logo.svg" />';
        L.DomEvent.disableClickPropagation(link);

        return container;
      },
    });
    const mapyLogo = new LogoControl();

    map.on('baselayerchange', function () {
      if (currentLayer?.id == 'satellite') {
        mapyLogo.remove();
      } else {
        mapyLogo.addTo(map);
      }
    });

    baseLayers.push({
      id: 'turist',
      name: 'Turista',
      layer: L.tileLayer(`https://api.mapy.com/v1/maptiles/outdoor/256/{z}/{x}/{y}?apikey=${API_KEY}`, {
        minZoom: 0,
        maxZoom: 19,
        attribution: mapy_attribution,
      })
    });

    baseLayers.push({
      id: 'winter',
      name: 'Téli',
      layer: L.tileLayer(`https://api.mapy.com/v1/maptiles/winter/256/{z}/{x}/{y}?apikey=${API_KEY}`, {
        minZoom: 0,
        maxZoom: 19,
        attribution: mapy_attribution,
      })
    });
  }
}